import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import NumberFormat from 'react-number-format';
import styles from './styles.module.scss';

import apiProduct from '../../../api/Product';
import ApiCart from '../../../api/Cart/CartApiFL';
import { getCart } from '../../../redux/actions/cartActions';
import Config, { spanish } from '../../../config/config';

import LinkLang from '../../Wraps/LinkLang';
import { ReactComponent as Fav } from '../../../assets/icons/icon-favorite.svg';
import { ReactComponent as Star } from '../../../assets/icons/icon-star-filled.svg';
import { ReactComponent as StarEmpty } from '../../../assets/icons/icon-star-outline.svg';

const Rating = ({ value }) => (
  <div className={styles.rating}>
    {value >= 1 ? <Star /> : <StarEmpty />}
    {value >= 2 ? <Star /> : <StarEmpty />}
    {value >= 3 ? <Star /> : <StarEmpty />}
    {value >= 4 ? <Star /> : <StarEmpty />}
    {value >= 5 ? <Star /> : <StarEmpty />}
  </div>
);

const Favorite = () => (
  <div className={styles.fav}>
    <div className={styles.favContent}>
      <div className={styles.favIcon}>
        <Fav />
      </div>
      <div className={styles.favMessage}>
        <p>Por favor inicia sesión para agregar productos a tus favoritos</p>
      </div>
    </div>
  </div>
);

const Item = ({ sku, productInfo }) => {
  const dispatch = useDispatch();
  const [info, setInfo] = useState(null);
  const cartId = useSelector((globalState) => globalState.cartInfo.IdCarrito);
  const stateId = useSelector(
    (globalState) => globalState.estadoSelection.selectedEstadoId
  );

  const onAddToCart = async (productId) => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      AgregarCarrito: {
        IdCarrito: cartId,
        IdEstado: stateId,
        TipoVenta: 1,
        FormaVenta: 3,
        IdFbo: 0,
        Productos: [
          {
            Cve_Prod: productId,
            Cantidad: 1,
            TipoUnidad: 'PI',
          },
        ],
      },
    };

    const resp = await ApiCart.addToCart(payload);
    if (resp.Codigo === 200) {
      if (resp.Codigo === 200) {
        dispatch(getCart(resp.IdCarrito));
      }
    }
  };

  useEffect(async () => {
    setInfo(await apiProduct.getSKU(sku));
  }, []);

  return (
    <div className={styles.container}>
      {info && (
        <>
          <div className={styles.image}>
            {info[0]?.imagesProduct[0]?.url && (
              <LinkLang to={`/product/${info[0]?.SLUG}`} state={{ sku }}>
                <img
                  src={Config.cdn.cdn_path + info[0]?.imageCatalog?.url}
                  alt={info[0]?.Name}
                />
              </LinkLang>
            )}
            <Favorite />
          </div>
          <Rating value={productInfo?.Calificacion} />
          <LinkLang
            to={`/product/${info[0]?.SLUG}`}
            className={styles.name}
            state={{ sku }}
          >
            {info[0]?.Name}
          </LinkLang>
          <p
            className={styles.specs}
          >{`${productInfo?.unidades_envase} ${productInfo?.presentacion}`}</p>
          <p className={styles.price}>
            <NumberFormat
              value={productInfo?.precioRetail}
              thousandSeparator
              prefix="$"
              suffix=" MXN"
              displayType="text"
            />
          </p>
          <button
            type="button"
            className="btn btn-white"
            onClick={() => onAddToCart(productInfo?.cve_prod)}
          >
            {spanish ? 'AGREGAR A LA BOLSA' : 'ADD TO BAG'}
          </button>
        </>
      )}
    </div>
  );
};

export default Item;
